// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.a3TableRows_a3container_zzuak {
  width: 389.5px;
  padding-left: 10px;
  height: fit-content;
}

.a3TableRows_wide_GQC5g {
  width: 589.5px;
}

.a3TableRows_emptyColumn_hmpC2 {
  width: 0px;
}

.a3TableRows_diagram_H3ZBQ {
  /* width: fit-content; */
  min-width: 389.5px;
  max-width: 1100px;
}

.a3TableRows_a3container_zzuak > *:not(:first-child) {
  margin-top: 10px;
}

.a3TableRows_a3root_BbygY {
  margin: 0px;
  color: black;
  min-width: 389.5px;
  background: white;
  border-radius: 15px;
  width: inherit;
}

.a3TableRows_a3tableHeaderContainer_zGYdD {
  margin-bottom: 3px;
  border-radius: 15px;
}

.a3TableRows_a3root_BbygY > *:nth-child(odd) {
  background-color: var(--timetable-accent-color);
}

.a3TableRows_a3root_BbygY > *:nth-child(even) {
  background-color: var(--light-background);
}

.a3TableRows_a3root_BbygY > *:first-child {
  border-top-left-radius: 15px;
  border-top-right-radius: 15px;
}

.a3TableRows_a3root_BbygY > *:last-child {
  border-bottom-right-radius: 15px;
  border-bottom-left-radius: 15px;
}

.a3TableRows_summer_BnvZc > *:nth-child(odd) {
  background-color: var(--light-background);
}

.a3TableRows_summer_BnvZc > *:nth-child(even) {
  background-color: var(--timetable-accent-color);
}

.a3TableRows_item_tJt8W {
  display: flex;
  min-width: 3.75em;
  padding: 0.25em 0;
  font-family: GothamXNarrow-Book;
  font-size: 0.75em;
  letter-spacing: -0.025em;
  line-height: 1;
  margin-right: 0.25em;
}

.a3TableRows_minutes_JeWlF {
  min-width: 0.75em;
  font-family: GothamXNarrow-Medium;
}

.a3TableRows_hours_fQX6C {
  padding-left: 0.938em;
  font-family: GothamXNarrow-Medium;
}
`, "",{"version":3,"sources":["webpack://./src/components/a3Timetable/a3TableRows.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,gCAAgC;EAChC,+BAA+B;AACjC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,iBAAiB;EACjB,+BAA+B;EAC/B,iBAAiB;EACjB,wBAAwB;EACxB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,iCAAiC;AACnC;;AAEA;EAEE,qBAAqB;EACrB,iCAAiC;AACnC","sourcesContent":[".a3container {\n  width: 389.5px;\n  padding-left: 10px;\n  height: fit-content;\n}\n\n.wide {\n  width: 589.5px;\n}\n\n.emptyColumn {\n  width: 0px;\n}\n\n.diagram {\n  /* width: fit-content; */\n  min-width: 389.5px;\n  max-width: 1100px;\n}\n\n.a3container > *:not(:first-child) {\n  margin-top: 10px;\n}\n\n.a3root {\n  margin: 0px;\n  color: black;\n  min-width: 389.5px;\n  background: white;\n  border-radius: 15px;\n  width: inherit;\n}\n\n.a3tableHeaderContainer {\n  margin-bottom: 3px;\n  border-radius: 15px;\n}\n\n.a3root > *:nth-child(odd) {\n  background-color: var(--timetable-accent-color);\n}\n\n.a3root > *:nth-child(even) {\n  background-color: var(--light-background);\n}\n\n.a3root > *:first-child {\n  border-top-left-radius: 15px;\n  border-top-right-radius: 15px;\n}\n\n.a3root > *:last-child {\n  border-bottom-right-radius: 15px;\n  border-bottom-left-radius: 15px;\n}\n\n.summer > *:nth-child(odd) {\n  background-color: var(--light-background);\n}\n\n.summer > *:nth-child(even) {\n  background-color: var(--timetable-accent-color);\n}\n\n.item {\n  display: flex;\n  min-width: 3.75em;\n  padding: 0.25em 0;\n  font-family: GothamXNarrow-Book;\n  font-size: 0.75em;\n  letter-spacing: -0.025em;\n  line-height: 1;\n  margin-right: 0.25em;\n}\n\n.minutes {\n  min-width: 0.75em;\n  font-family: GothamXNarrow-Medium;\n}\n\n.hours {\n  composes: item;\n  padding-left: 0.938em;\n  font-family: GothamXNarrow-Medium;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"a3container": `a3TableRows_a3container_zzuak`,
	"wide": `a3TableRows_wide_GQC5g`,
	"emptyColumn": `a3TableRows_emptyColumn_hmpC2`,
	"diagram": `a3TableRows_diagram_H3ZBQ`,
	"a3root": `a3TableRows_a3root_BbygY`,
	"a3tableHeaderContainer": `a3TableRows_a3tableHeaderContainer_zGYdD`,
	"summer": `a3TableRows_summer_BnvZc`,
	"item": `a3TableRows_item_tJt8W`,
	"minutes": `a3TableRows_minutes_JeWlF`,
	"hours": `a3TableRows_hours_fQX6C a3TableRows_item_tJt8W`
};
module.exports = ___CSS_LOADER_EXPORT___;
